const reportTypes = {
  EOD_BY_MERCHANT: 1,
  EOD_BY_BRANCH: 2,
  EOD_BY_CLIENT: 3,
  EOD_TRANSACTION: 4,
};

export default reportTypes;
